import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { keyBy } from 'lodash';

import type { RoleTypeDTO, User, UserDTO, UserRole } from './Users.types';

export const usersAtom = atom<User[]>([]);
export const userTablePageAtom = atom(0);
export const userTableRowsAtom = atomWithStorage('OrganizationTablesRows', 25);

export const rolesDialogOpenAtom = atom(false);
export const roleTypesAtom = atom<RoleTypeDTO>([]);
export const roleTypesIdMapAtom = atom((get) =>
  keyBy(get(roleTypesAtom), 'id')
);

export const mapUserDTO = (user: UserDTO, orgLabel: string): User => {
  let roles: UserRole[] = [];
  if (user.roles?.[orgLabel]) {
    roles = user.roles[orgLabel].map(({ role_id, name }) => ({
      role_id,
      name
    }));
  }

  return {
    ...user,
    roles,
    organization_count: user.organizations.length,
    is_service_account: user.is_service_account ?? false
  };
};
